export function getStartEpochTimeInMillisecondsFromUTC(dateString: string) {
	const dateObj = new Date(dateString);
	dateObj.setHours(0, 0, 0, 0);

	return dateObj.getTime();
}

export function getEndOfDayEpochTimeInMillisecondsFromUTC(dateString: string) {
	const dateObj = new Date(dateString);
	dateObj.setHours(23, 59, 59, 999);

	return dateObj.getTime();
}
